import { LinkOutlined } from '@ant-design/icons'
import { Button, Col, Input, notification, Popconfirm, Row, Table } from 'antd'
import { compact } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { handleBackendError } from '../../../../utils'

import { getUserList, updateUser } from '../../../users/api'

export const ConvertAndConnectUser = ({ selectedStore }) => {
  const userFilterParams = `country_id=${selectedStore.country_id}&items_per_page=200&page=1&sort_by=created_at+DESC&user_type=regular&status[]=validation_needed&status[]=registered`

  const [isLoading, setIsLoading] = useState(false)
  const [localFilter, setLocalFilter] = useState('')
  const [filteredUserList, setFilteredUsers] = useState([])

  useEffect(() => {
    fetchUserList(userFilterParams)
  }, [])

  const fetchUserList = (params) => {
    setIsLoading(true)

    getUserList(params)
      .then(({ data }) => {
        setFilteredUsers(data.data)
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)

        notification.error({
          description: handleBackendError(error, 'Fetching user list failed!'),
          title: 'Error',
        })
      })
  }

  const tableColumns = compact([
    {
      className: 'userNameSelenium',
      dataIndex: 'name',
      filteredValue: localFilter.name,
      key: 'name',
      title: 'Name',
    },
    {
      className: 'emailSelenium',
      dataIndex: 'email',
      filteredValue: localFilter.email,
      key: 'email',
      title: 'Email',
    },
    {
      className: 'userActionSelenium',
      key: 'action',
      render: (_, record) => (
        <Popconfirm
          cancelText="No"
          description="Are you sure?"
          okText="Yes"
          onConfirm={() => handleConnecting(record)}
          title={`Convert & connect user to the ${selectedStore.name} store`}
        >
          <Button type="link">
            <LinkOutlined />
          </Button>
        </Popconfirm>
      ),
      width: 30,
    },
  ])

  const handleConnecting = ({ id }) => {
    setIsLoading(true)

    const fieldsValue = {
      id,
      store_id: selectedStore.id,
      user_type: 'corporate',
    }

    updateUser(fieldsValue)
      .then(() => {
        notification.success({
          description: `Corporate user converted & connected to ${selectedStore.name} successfully`,
          duration: 5,
          title: 'Success',
        })

        fetchUserList(userFilterParams)
      })
      .catch((error) => {
        notification.error({
          description: handleBackendError(error, 'Corporate user convert & connect failed!'),
          title: 'Error',
        })
        setIsLoading(false)
      })
  }

  return (
    <Row style={{ marginTop: '20px' }}>
      <Col span={24}>
        <Input
          onChange={(e) => setLocalFilter(e.target.value ? e.target.value : '')}
          placeholder="Email or name"
          style={{ display: 'block', marginBottom: 8 }}
          value={localFilter}
        />
      </Col>

      <Col span={24}>
        <Table
          className="usersPageTableSelenium"
          columns={tableColumns}
          data-testid="usersTable"
          dataSource={filteredUserList.filter(
            (user) =>
              (user.email.toLowerCase().includes(localFilter.toLowerCase()) ||
                user.name.toLowerCase().includes(localFilter.toLowerCase())) &&
              user.number_of_returned_items === 0 &&
              parseFloat(user.balance) === 0,
          )}
          loading={isLoading}
          rowKey="id"
        />
      </Col>
    </Row>
  )
}

ConvertAndConnectUser.propTypes = {
  resetSelectedMenu: PropTypes.func,
  selectedStore: PropTypes.object,
}

export default ConvertAndConnectUser
